import { Directive, ElementRef, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Address } from './Address';

@Directive({
  selector: '[appGooglePlacesAutocomplete]',
  exportAs: 'appGooglePlacesAutocomplete'
})
export class GooglePlacesAutocompleteDirective implements AfterViewInit {
  @Output() addressChange = new EventEmitter<Address>();
  @Output() inputChange = new EventEmitter<string>();

  constructor(private el: ElementRef<HTMLElement>) {}

  ngAfterViewInit() {
    const element = this.el.nativeElement as HTMLElement;

    element.addEventListener('gmp-select', async (event: any) => {
      try {
        const prediction = event.placePrediction;
        if (prediction) {
          const place = prediction.toPlace();
          await place.fetchFields({
            fields: ['addressComponents', 'location', 'id', 'timeZone']
          });
          this.addressChange.emit(this.parseAddress(place));
        }
      } catch (error) {
        console.error('Failed to fetch selected place details.', error);
      }
    });

    element.addEventListener('input', () => {
      this.inputChange.emit(element['inputValue'] || '');
    });

    this.updateShadowGoogleElementStylesSheet(element);
  }

  public setValue(value: string) {
    if (this.el.nativeElement) {
      (this.el.nativeElement as any).inputValue = value || '';
    }
  }

  private getAddrComponent(place: any, type: string): string {
    const components = place.addressComponents;
    if (!components) { return null; }

    const component = components.find((c: any) => c.types.includes(type));
    return component ? component.longText : null;
  }

  private parseAddress(place: any): Address {
    const lat = typeof place.location?.lat === 'function' ? place.location.lat() : place.location?.lat;
    const lng = typeof place.location?.lng === 'function' ? place.location.lng() : place.location?.lng;

    return {
      id: place.id,
      city: this.getAddrComponent(place, 'locality') || this.getAddrComponent(place, 'sublocality_level_1'),
      street: `${this.getAddrComponent(place, 'street_number') || ''} ${this.getAddrComponent(place, 'route') || ''}`.trim(),
      state: this.getAddrComponent(place, 'administrative_area_level_1'),
      zip: this.getAddrComponent(place, 'postal_code'),
      lat: lat || null,
      lng: lng || null,
      timeZoneId: place.timeZone?.id
    };
  }

  private updateShadowGoogleElementStylesSheet(element: HTMLElement) {
    setTimeout(() => {
      const shadow = element.shadowRoot;

      if (shadow) {
        const sheet = new CSSStyleSheet();

        (sheet as any).replaceSync(`
            .focus-ring {
              border: none !important;
              box-shadow: none !important;
              outline: none !important;
              display: none !important;
            }
            .input-container button.clear-button:hover {
              background-color: transparent !important;
            }
           `);

        const shadowRoot = shadow as any;
        shadowRoot.adoptedStyleSheets = [...(shadowRoot.adoptedStyleSheets || []), sheet];
      } else {
        console.warn('Shadow DOM not found.');
      }
    }, 100);
  }
}
